function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Streetlight-Outage",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "A.1.3-Mobile-Streetlight-Outage---Non-NG-Light",
  transform: "translate(-327.000000, -718.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 691.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(327.000000, 27.000000)",
  id: "light-bulb-shine"
}, /*#__PURE__*/React.createElement("line", {
  x1: 17.1609821,
  y1: 29.921174,
  x2: 11.8038393,
  y2: 29.921174,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.2324107,
  y1: 27.7878407,
  x2: 10.7324107,
  y2: 27.7878407,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.4824107,
  y1: 0.0545071187,
  x2: 14.4824107,
  y2: 2.18784067,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.53524554,
  y1: 4.621374,
  x2: 4.90821429,
  y2: 5.98824067,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.4201786,
  y1: 4.621374,
  x2: 23.5895536,
  y2: 5.98824067,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.0181252198,
  y1: 14.4545073,
  x2: 2.16098214,
  y2: 14.4545073,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 28.9466964,
  y1: 14.4545073,
  x2: 26.8038393,
  y2: 14.4545073,
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7145583,14.2574423 C21.7186166,10.6549632 19.1287035,7.54634433 15.5166651,6.81824573 C11.9046267,6.09014714 8.26640078,7.94332547 6.81007242,11.2530635 C5.35374405,14.5628014 6.48086279,18.4165139 9.50736607,20.4753342 C9.8553309,20.7117343 10.062789,21.0995356 10.0627679,21.5135463 L10.0627679,22.4771488 C10.0627679,22.8263503 10.3525835,23.109434 10.7100893,23.109434 L17.1833036,23.109434 C17.5408093,23.109434 17.830625,22.8263503 17.830625,22.4771488 L17.830625,21.5122818 C17.8306038,21.098271 18.038062,20.7104697 18.3860268,20.4740696 C20.4720106,19.0603279 21.7157601,16.7374002 21.7145583,14.2574423 L21.7145583,14.2574423 Z",
  id: "Path",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("text", {
  id: "?",
  fontFamily: "HelveticaNeue-Medium, Helvetica Neue",
  fontSize: 10,
  fontWeight: 400,
  letterSpacing: -0.142857167,
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 11,
  y: 19
}, "?"))))));

var SvgHelpLightBulb = function SvgHelpLightBulb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 31",
    className: "icon icon-help-light-bulb",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpLightBulb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-light-bulb.4da4c611.svg";
export { ForwardRef as ReactComponent };